import { SET_CURRENT_MEAL_RESERVATION, RESET_CURRENT_MEAL_RESERVATION, SET_MEAL_RESERVATIONS_LIST } from "./types";
import backend, { recursiveRequest } from "../apis/backend";
import errorHandler from "../helpers/errorHandler";
import store from "../store";

export const getUserMealReservation = (date) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/meal-reservations/my?date=${date}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_CURRENT_MEAL_RESERVATION, payload: response.data.mealReservation });
    }
    catch (error) { errorHandler(error, null); }
};

export const getMealReservations = (date) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.get(`/api/meal-reservations?date=${date}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_MEAL_RESERVATIONS_LIST, payload: response.data.mealReservations });
    }
    catch (error) { errorHandler(error, null); }
};

export const newMealReservation = (formValues, onFieldError) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.post(`/api/meal-reservations`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_CURRENT_MEAL_RESERVATION, payload: response.data.mealReservation });
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const editMealReservation = (orderID, formValues, onFieldError) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.patch(`/api/meal-reservations/${orderID}`, formValues, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: SET_CURRENT_MEAL_RESERVATION, payload: response.data.mealReservation });
    }
    catch (error) { errorHandler(error, onFieldError); }
};

export const deleteMealReservation = (orderID) => async (dispatch) => {
    try {
        const response = await recursiveRequest(async () => {
            return await backend.delete(`/api/meal-reservations/${orderID}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${store.getState().auth.token || ""}`
                }
            });
        });

        if (response) dispatch({ type: RESET_CURRENT_MEAL_RESERVATION, payload: {} });
    }
    catch (error) { errorHandler(error, null); }
};